module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_orange_selected.a083c7c4.svg";